module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Regular.10443314175057432e84f7cc49229e37.otf";